module.exports = __webpack_public_path__ + "img/hut_yes.11c7610b.png";